import React from 'react';
import TabContainer from '../../../../../common/components/tab/containers/tab.containers';
import WebsiteCardComponent from './website-cards.components';
import { WebsitesBasicInfoComponent } from './website-basic-info.commponent';



export const WebsitesComponent = ({ back, handleFormSubmit, handleInnerFormChange, selectedTenantWebsites, websites, departments, stores, Id, onDelete, additionButtons, onEdit, rowData, columnDefs }: any) => {
  const tabItems = [
    {
      id: 1,
      title: 'Basic Information',
      component: <WebsitesBasicInfoComponent
        onInnerFormChange={handleInnerFormChange}
        selectedTenantWebsites={selectedTenantWebsites}
        stores={stores}
        websites={websites}
        departments={departments} />,
      isVisible: Id == 0 ? true : false,
    },
    {
      id: 1,
      title: ' Website Cards ',
      component: <WebsiteCardComponent
        onDelete={onDelete}
        additionButtons={additionButtons}
        rowData={rowData}
        columnDefs={columnDefs}
        onEdit={onEdit}
      />,
      isVisible: Id > 0 ? true : false,
    }

  ]

  return (
    <div className="flex flex-col items-center w-full px-5 overflow-auto h-auto pb-20">


      <TabContainer tabItems={tabItems} />
      {Id == 0 ? (
        <div className='flex w-full justify-end items-end h-20'>

          <button
            onClick={back}
            type='button'
            className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
          >
            Back
          </button>



          <button
            className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
            onClick={handleFormSubmit}

            type="submit"
          >
            Save
          </button>
        </div>
      ) : null}
    </div>
  )
}
export default WebsitesComponent;
